import React, { FC, CSSProperties, useState } from 'react';

import { IconProps } from '../types/icon.types';
import { useBreakpoint } from '../hooks/useBreakpoint';
import { Breakpoint } from '../utils/breakpoint';

// Пропсы для конечного компонента.
// Обратите внимание, что 'OverlayComponent' здесь больше не нужен.
export interface IWithOverlayIconProps<OP extends IconProps> {
  overlayProps: OP; // Пропсы для компонента-оверлея
  showOverlay?: boolean; // Флаг для условного отображения оверлея
  offsetX?: string | number; // Смещение по оси X
  offsetY?: string | number; // Смещение по оси Y
  disabled?: boolean;
  tooltip?: string;
}

export const withOverlayIcon = <P extends object, OP extends IconProps>(
  WrappedComponent: React.ComponentType<P>,
  OverlayComponent: React.ComponentType<OP>,
) => {
  const WithOverlayIcon: FC<P & IWithOverlayIconProps<OP>> = ({
    overlayProps,
    showOverlay = true,
    offsetX = '50%',
    offsetY = '-50%',
    disabled,
    tooltip,
    ...props
  }) => {
    const [isHovered, setIsHovered] = useState(false);
    const breakpoint = useBreakpoint();
    const isShowHover = breakpoint > Breakpoint.Md && isHovered && !disabled;

    const hoverProps =
      disabled || !tooltip
        ? {}
        : {
            onMouseEnter: () => setIsHovered(true),
            onMouseLeave: () => setIsHovered(false),
          };

    const containerStyle: CSSProperties = {
      position: 'relative',
    };

    const overlayStyle: CSSProperties = {
      position: 'absolute',
      top: 0,
      right: 0,
      transform: `translate(${offsetX}, ${offsetY})`,
      pointerEvents: 'none',
    };

    return (
      <div style={containerStyle} {...hoverProps}>
        {/* Основной компонент (Иконка А) */}
        <WrappedComponent {...(props as P)} />

        {/* Оверлей (Иконка Б) */}
        {showOverlay && (
          <div style={overlayStyle}>
            <OverlayComponent {...overlayProps} />
          </div>
        )}
        {isShowHover && (
          <div className="absolute z-[100] flex flex-row min-w-[231px] !bg-white max-w-[231px] text-[10px] font-manrope rounded-[5px] border-1 p-1 border-[#C00000] items-start ">
            <p className="mt-1">{tooltip}</p>
          </div>
        )}
      </div>
    );
  };

  return WithOverlayIcon;
};
